$(function () {
	'use strict';

	//lazyload
	lazyload();

	//PDF Link
	$("a[href*='.pdf']").attr("target", "_blank");

	// 外部リンクに target="_blank"を付ける
	$("a[href]").each(function () {
		if (!this.href.match(new RegExp("^(#|\/|(https?:\/\/" + location.hostname + "))"))) {
			$(this).attr("target", "_blank");
		}
	});


	//header SHOP BTN
	//$('.shopNav__btn').click(function () {
		//$(this).toggleClass('is-active').next().slideToggle(500);
	//});
	
	let shopNavBtn = $('.shopNav__btn');
	$('.shopNav').hover(function(){
		shopNavBtn.addClass('is-active').next().slideDown(500);
	}, function(){
		shopNavBtn.removeClass('is-active').next().slideUp(500);
	});


	//scroll header
	$(window).scroll(function () {
		if ($(window).scrollTop() > 80) {
			$('#shopify-section-header').addClass('is-active');
		} else {
			$('#shopify-section-header').removeClass('is-active');
		}
	});

	//SP ShopNav
	$('.menu-toggle').click(function () {
		$(this).toggleClass('is-active').next().slideToggle(500);
	});

});